import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '@nwwp/ui-shadcn'

const sectionOuterVariants = cva('w-full', {
  variants: {
    paddingY: {
      none: '',
      xs: 'py-6 tablet:py-10',
      sm: 'py-16 tablet:py-20',
      md: 'py-16 tablet:py-25',
    },
  },
  defaultVariants: {
    paddingY: 'md',
  },
})

const sectionInnerVariants = cva('', {
  variants: {
    maxWidth: {
      full: 'max-w-full px-4 tablet:px-25', // matches navbar & footer
      lg: 'mx-auto max-w-screen-lg px-4',
    },
  },
  defaultVariants: {
    maxWidth: 'lg',
  },
})

type SectionProps = React.ComponentProps<'section'> &
  VariantProps<typeof sectionOuterVariants> &
  VariantProps<typeof sectionInnerVariants> & {
    innerClassName?: string
  }

function Section({ paddingY, maxWidth, className, innerClassName, children, ...props }: SectionProps) {
  return (
    <section
      data-slot="section"
      data-padding-y={paddingY}
      className={cn('grow', sectionOuterVariants({ paddingY }), className)}
      {...props}
    >
      <div data-slot="section-inner" className={cn(sectionInnerVariants({ maxWidth }), innerClassName)}>
        {children}
      </div>
    </section>
  )
}

export { Section, sectionOuterVariants, sectionInnerVariants }
